<template>
    <Editor
        style="min-height: 400px;"
        :init="config"
        @onBlur="$emit('blur')"
        v-model="model"/>
</template>

<script>

import FormInput from "@/Mixins/FormInput";
import Editor from '@tinymce/tinymce-vue'

export default {

    name: 'Wysiwyg',

    mixins: [FormInput],

    props: {
        placeholder: {},
    },

    data() {
        return {
            config: {
                menubar: false,
                placeholder: this.placeholder,
                plugins: [
                    'link',
                    'lists',
                    'fullscreen',
                    'code'
                ],
                toolbar: [
                    'bold italic underline strikethrough',
                    'alignleft aligncenter alignright alignjustify',
                    'subscript superscript',
                    'formatselect removeformat',
                    'link unlink',
                    'bullist numlist',
                    'fullscreen', 'code'
                ].join(' | '),
                table_advtab: false,
                relative_urls: false,
                remove_script_host: true,
                image_dimensions: false,
                image_caption: true,
                body_class: "prose prose-sm max-w-none p-4",
                content_css: '/css/app.css',
                table_header_type: 'sectionCells',
            }
        };
    },

    components: {
        Editor
    },
};

</script>
